module.exports = __webpack_public_path__ + "img/BateriaPanelEnActivacion.b32f4542.svg";